import GeneralService from "./GeneralService";
import { ApiKeyOrGetter } from "./GeneralService";

export class EvaluationCriteriaService {
  public static getAvailable(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/evaluation-criteria/available",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static list(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/evaluation-criteria/",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static create(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      "/evaluation-criteria/",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static update(
    criteriaId: number,
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.put(
      `/evaluation-criteria/${criteriaId}`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deleteCriteria(
    criteriaId: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.delete(
      `/evaluation-criteria/${criteriaId}`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
